import React from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import Admonition from "../../components/Admonitions/Admonition"
import {clearCheckDeposit} from "../../resources/checkDeposits"

interface ClearCheckModalProps {
	id: string
	closeModal: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function ClearCheckModal({id, closeModal, onSuccess}: ClearCheckModalProps) {
	const accessToken = useAccessToken()
	const [clearState, setClearState] = useAsyncResultIdle(clearCheckDeposit)

	return (
		<AsyncResultModal
			title={`You Are About To Clear Check ID #${id}`}
			close={refreshAndClose(onSuccess, closeModal)}
			buttonClassname="is-success"
			state={clearState}
			buttonText="Clear"
			successText="Check is cleared"
			onSubmit={() => {
				setClearState({id, accessToken})
			}}
			errorToText={(err) => err.errors[0].title}
		>
			<Admonition
				type={"is-info"}
				message={
					<p>
						Clearing the check ahead of the scheduled clearing time increases the risk of return-related losses. Are you
						sure you want to continue?
					</p>
				}
				title={"Note"}
			/>
		</AsyncResultModal>
	)
}
